import React, {RefObject} from 'react';
// import { TCutState } from "modules/cut";
import {CSS_TIMELINE_PLAYHEAD} from 'constants/dom';
import {TDisplayWarn} from 'hooks/useEditWarn';
// import CutArea from "components/edit/CutArea";
import {t} from 'lib/i18n';

interface IEditWrap {
  wrapRef: RefObject<HTMLDivElement>;
  innerRef: RefObject<HTMLDivElement>;
  hoverRef: RefObject<HTMLDivElement>;
  playHeadRef: RefObject<HTMLDivElement>;
  flowRef: RefObject<HTMLDivElement>;
  playHead: {
    cssClass: string;
    transX: number;
  };
  flowHead: {
    left: number;
  };
  wrapHover: {
    px: number;
    cssClass: string;
    convertTime: string;
  };
  // cut: TCutState;
  onClickDivision: (
    e: MouseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
  // shadeStyle: {};
  divideBtn: string;
  displayEditWarn: TDisplayWarn;
}

/**
 * 편집 하는 영역 컴포넌트
 */
const EditWrap = ({
  wrapRef,
  innerRef,
  hoverRef,
  playHeadRef,
  flowRef,
  playHead,
  flowHead,
  wrapHover,
  // cut,
  onClickDivision,
  // shadeStyle,
  divideBtn,
  displayEditWarn,
}: IEditWrap) => {
  // 재생 바 헤드
  const playHeadStyle = {
    transform: `translateX(${playHead.transX}px)`,
  };
  // 편집 영역 마우스 오버 시 현재 마우스 시점 표시
  const wrapStyle = {
    transform: `translateX(${wrapHover.px}px)`,
  };
  const flowStyle = {
    left: `${flowHead.left}px`,
  };

  const editWarnClass = displayEditWarn.display ? 'error' : ''; // 편집 영역 구간 선택 문구 투명도 클래스

  return (
    <div
      className='div_editor_wrap'
      id='wrap'
      ref={wrapRef}
      style={{width: `calc(100% - 40px)`, left: '20px'}}>
      <div
        className={'div_editor_inner ' + editWarnClass}
        ref={innerRef}
        id='inner'>
        <div className='timeline_flow' ref={flowRef} style={flowStyle}></div>
        <div className='timeline_start'></div>
        <div
          className={'timeline_hover_line ' + wrapHover.cssClass}
          style={wrapStyle}
          ref={hoverRef}>
          <div className='label'>{wrapHover.convertTime}</div>
        </div>
        <div
          className={CSS_TIMELINE_PLAYHEAD + ' ' + playHead.cssClass}
          style={playHeadStyle}
          ref={playHeadRef}>
          <button
            type='button'
            className={'div_btn ' + divideBtn}
            onClick={onClickDivision}>
            <span>{t('분할')}</span>
          </button>
        </div>
        <div className='timeline_end'></div>

        <div id='editArea'></div>

        {/* {cut.status && (
                    cut.infos[0].cutIdx === 0 && (
                        <>
                            <CutShadesArea order="first" />
                            <CutSelectedArea />
                            <CutShadesArea order="last" />
                        </>
                    )
                )}
                {cut.infos[0].cutIdx !== 0 && (
                    cut.infos.map((idx, info) => {

                    })
                )} */}

        {/* {cut.status && <CutArea cut={cut} />} */}
      </div>
    </div>
  );
};

export default EditWrap;
